import type { Components, Theme } from '@mui/material'

export const MuiAppBar = (theme: Theme): Components['MuiAppBar'] => ({
  defaultProps: { position: 'relative' },
  styleOverrides: {
    root: {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      boxShadow: theme.elevations.level1,
      height: 56,
      WebkitBackdropFilter: 'var(--mui-appbar-backdrop-filter, none)',
      backdropFilter: 'var(--mui-appbar-backdrop-filter, none)',
    },
  },
})

export const MuiToolbar = (theme: Theme): Components['MuiToolbar'] => ({
  styleOverrides: {
    root: {
      [theme.breakpoints.up('sm')]: {
        minHeight: 56,
        paddingRight: theme.spacing(2),
        paddingLeft: theme.spacing(2),
      },
      '@media (min-width:0px) and (orientation: landscape)': {
        minHeight: 56,
      },
    },
  },
})
